import React, {useState, useEffect, useRef} from "react";
import {useHistory, useLocation} from "react-router-dom";
//components
import SplashScreen from "../components/SplashScreen";
import Faq from "../components/Faq";
import TimeCounter from "../components/TimeCounter";
import RefreshLogo from "../components/svg/RefreshLogo";
import HeadingPrimary from "../components/HeadingPrimary";
// import CustomDatePicker from "../components/CustomDatePicker";
import DotLoading from "../components/DotLoading";
// import {fixNumbers} from "../helper/helper";

//constants
import localStorageKeys from "../constants/localStorageKeys.enum";

//services
import authService from "../services/auth.service";

//hooks
import {useForm} from "../hooks/useForm";
import OtpInput from "react-otp-input";
import {BottomSheet} from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";

//styles
import "../styles/main.scss";
import IntroScreen from "../components/IntroScreen";
import CustomDatePicker2 from "../components/CustomDatePicker2";
import qs from "qs";
import CONSTANTS from "../constants/constant.enum";
import BirthDatePickerWithSeparateSelect from "../components/BirthDatePickerWithSeparateSelect";

const Login: React.FC<any> = (props: any) => {
  // states
  const [otp, setOtp] = useState("");
  const [showFaqSection, setShowFaqSection] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [resendText, setResendText] = useState(false);
  const [showTimer, setShowtimer] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [screenSplash, setScreenSplash] = useState(true);
  const [showActivationCodeBox, setShowActivationCodeBox] = useState(false);
  const [isDisabledCaptcha, setIsDisabledCaptcha] = useState(true);
  const [errors, setErrors] = useState([]) as any;
  const [inputDateValue, setInputDateValue] = useState("");
  const [captchaCode, setCaptchaCode] = useState("");
  const [inputCaptchaId, setInputCaptchaId] = useState("");
  const [date, setDate] = useState({
    day: 11,
    month: 12,
    year: 1364
  });
  // const [secondButtonText, setSecondButtonText] = useState(false);
  const history = useHistory();

  const windowSize = window.innerWidth;

  // refs
  const activationCodeTag = useRef<HTMLInputElement>(null);
  const captchaTag = useRef<HTMLInputElement>(null);

  // defining the initial state for the form
  const initialState = {
    nationalId: "",
    birthDate: "",
    mobileNumber: "",
    captcha: {
      code: "",
      id: "",
    },
  };

  // getting the event handlers from our custom hook
  const {
    onChange,
    onPress,
    onCaptchaChange,
    onBirthDateChange,
    onSubmit,
    values,
  } = useForm(loginUserCallback, initialState, setErrors);

  // a submit function that will execute upon form submission
  async function loginUserCallback() {
    // send "values" to database
    setIsLoading(true);
    // console.log(values);
    authService
      .login(values)
      .then((response) => {
        // console.log("is ok");
        setShowActivationCodeBox(true);
        setShowtimer(true);
        activationCodeTag.current!.focus();
      })
      .catch((error: any) => {
        if (error.response) {
          const {errors, message} = error.response.data;
          if (error.response.status === 500) {
            setErrors([{field: "", message: "خطا در سرور"}]);
            return false;
          }
          if (message !== null) {
            setErrors([{field: "captcha", message: message}]);
            handleCaptcha();
            emptyCaptchaTag();
          } else {
            const incompatibility = errors.find((error: any) => {
              return error.message === "عدم تطابق کد ملی با تلفن همراه.";
            });
            if (incompatibility) {
              setErrors([
                {
                  field: "mobileNumber",
                  message: "عدم تطابق کد ملی با تلفن همراه.",
                },
                {
                  field: "nationalId",
                  message: "",
                },
              ]);
              emptyCaptchaTag();
              handleCaptcha();
            } else {
              setErrors(errors);
            }
          }
        } else {
          setErrors([{field: "", message: "خطا در سرور"}]);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  //use effects
  useEffect(() => {
    handleCaptcha();
    return () => {
      setCaptchaCode("");
      setInputCaptchaId("");
    };
  }, []);

  const queryStringParsed = qs.parse(props.location.search.slice(1));

  //functions
  const checkActivationCode = (e: any = null, otpParam: any = null) => {
    // const codeValue = fixNumbers(e.target.value);

    const dataFinilize = {
      activationCode: otpParam,
      mobileNumber: values.mobileNumber,
    };

    // console.log(dataFinilize);

    if (otpParam.length === 6) {
      setIsLoading(true);
      authService
        .loginFinalize(dataFinilize)
        .then((res) => {
          localStorage.setItem(
            localStorageKeys.tokenInfo,
            JSON.stringify({
              ...res.data,
              nationalId: values.nationalId,
              birthDate: values.birthDate,
              mobileNumber: values.mobileNumber,
            })
          );

          if (queryStringParsed[CONSTANTS.userHealthQrCodeParam]) {
            history.push(
              "/profile?" +
              CONSTANTS.userHealthQrCodeParam +
              "=" +
              queryStringParsed.userHealthQrCode
            );
            return;
          }
          if (queryStringParsed[CONSTANTS.guildQrCodeParam]) {
            history.push(
              "/guild?" +
              CONSTANTS.guildQrCodeParam +
              "=" +
              queryStringParsed.guildQrCode
            );
            return;
          }
          history.push("/profile");
        })
        .catch((error: any) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response) {
              const {message} = error.response.data;
              if (error.response.status === 412) {
                setErrors([{field: "activationCode", message: message}]);
                emptyCaptchaTag();
              }
            } else if (error.response.status === 500) {
              setErrors([{field: "", message: "خطا در سرور"}]);
            } else if (error.response.status === 503) {
              const {message} = error.response.data;
              setErrors([{field: "", message: message}]);
            }
            // console.log(typeof error.response.status);
            // console.log(error.response.status);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("Error", error.message);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };
  const handleCaptcha = async () => {
    const {data} = await authService.captcha();
    setCaptchaCode(data.captchaBase64);
    setInputCaptchaId(data.id);
  };

  const showFaq = () => {
    setShowFaqSection(!showFaqSection);
  };

  const handleShowDatePicker = (e: any) => {
    e.target.classList.remove("input-error");
    setErrors([]);
    setShowDatePicker(true);
  };

  const emptyCaptchaTag = () => {
    captchaTag.current!.value = "";
  };

  useEffect(() => {
    demoAsyncCall().then(() => setScreenSplash(false));
  }, [isLoading]);

  function demoAsyncCall() {
    return new Promise((resolve: any) => setTimeout(() => resolve(), 4000));
  }

  let hasIntro = "yes";
  (() => {
    try {
      let getHasIntro = localStorage.getItem("hasIntro");
      if (getHasIntro === "yes") {
        hasIntro = "yes";
        return;
      }
      hasIntro = "no";
    } catch (e) {
      hasIntro = "no";
    }
  })();

  const [stateHasIntro, setStateHasIntro] = useState(false);

  const activationCodeButtonRef = useRef<any>(null);
  const handleOtpChange = (otp: any) => {
    setOtp(otp);
    if (parseInt(otp.length) === 6) {
      checkActivationCode(null, otp);
      activationCodeButtonRef.current.removeAttribute("disabled");
    } else {
      activationCodeButtonRef.current.setAttribute("disabled", "true");
    }
  };
  const scrollTop = useRef<any>(null);
  const scrollToTop = () => {
    scrollTop.current?.scrollIntoView({behavior: "smooth"});
  };

  useEffect(() => {
    if (stateHasIntro) {
      setTimeout(() => {
        scrollToTop();
      }, 1000);
    }
  }, [stateHasIntro]);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('code')) {
      setIsLoading(true);
      authService
        .loginWithSSO({
          code: params.get('code'),
          redirectUri: window.location.origin + '/'
        })
        .then((res) => {
          localStorage.setItem(
            localStorageKeys.tokenInfo,
            JSON.stringify({
              ...res.data,
              nationalId: values.nationalId,
              birthDate: values.birthDate,
              mobileNumber: values.mobileNumber,
            })
          );

          if (queryStringParsed[CONSTANTS.userHealthQrCodeParam]) {
            history.push(
              "/profile?" +
              CONSTANTS.userHealthQrCodeParam +
              "=" +
              queryStringParsed.userHealthQrCode
            );
            return;
          }
          if (queryStringParsed[CONSTANTS.guildQrCodeParam]) {
            history.push(
              "/guild?" +
              CONSTANTS.guildQrCodeParam +
              "=" +
              queryStringParsed.guildQrCode
            );
            return;
          }
          history.push("/profile");
        })
        .catch((error: any) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response) {
              const {message} = error.response.data;
              if (error.response.status === 412) {
                setErrors([{field: "activationCode", message: message}]);
                emptyCaptchaTag();
              }
            } else if (error.response.status === 500) {
              setErrors([{field: "", message: "خطا در سرور"}]);
            } else if (error.response.status === 503) {
              const {message} = error.response.data;
              setErrors([{field: "", message: message}]);
            }
            // console.log(typeof error.response.status);
            // console.log(error.response.status);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("Error", error.message);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [location.search])

  return (
    <>
      {screenSplash && !(new URLSearchParams(props.location.search).get("code")) ? (
        <SplashScreen/>
      ) : hasIntro !== "yes" && !stateHasIntro ? (
        <IntroScreen setStateHasIntro={setStateHasIntro}/>
      ) : (
        <main className="app">
          {/* <CustomDatePicker onBirthDateChange={onBirthDateChange} onShowDatePicker={showDatePicker}
                          onSetShowDatePicker={setShowDatePicker}
                          onSetInputDateValue={setInputDateValue}/> */}
          <CustomDatePicker2
            onBirthDateChange={onBirthDateChange}
            onSetInputDateValue={setInputDateValue}
            onShowDatePicker={showDatePicker}
            onSetShowDatePicker={setShowDatePicker}
          />

          <Faq
            onShowFaqSection={showFaqSection}
            onSetShowFaqSection={showFaq}
          />
          <section className="login-page" ref={scrollTop}>
            <div className="u-margin-bottom-small-2">
              <HeadingPrimary/>
            </div>
            <div className="login u-margin-bottom-small-2">
              <h6 className="login__title u-margin-bottom-small-1">
                ورود کاربران
              </h6>
              <form className="login__form" onSubmit={onSubmit}>
                <>
                  <BottomSheet open={showActivationCodeBox}>
                    <div className="activation-code-bottom-sheet">
                      <div className="activation-code-bottom-sheet__header">
                        کد فعالسازی ارسال شده به شماره تلفن همراه
                        <span> {values.mobileNumber} </span>
                        وارد بفرمایید .
                      </div>
                      <div className="activation-code-bottom-sheet__otp">
                        <OtpInput
                          value={otp}
                          onChange={handleOtpChange}
                          numInputs={6}
                          isInputNum={true}
                        />
                      </div>
                      <div
                        className={`activation-code-bottom-sheet__resend ${
                          showTimer
                            ? "activation-code-bottom-sheet__resend--disable"
                            : "activation-code-bottom-sheet__resend--active"
                        }`}
                      >
                        <button className="">ارسال مجدد کد فعالسازی</button>
                        <span>:</span>
                        <span>
                          <TimeCounter
                            onHandleCaptcha={handleCaptcha}
                            onHandleDisableCaptcha={setIsDisabledCaptcha}
                            onHandleEmptyCaptchaTag={emptyCaptchaTag}
                            onHandleSetShowTimer={setShowtimer}
                            setResendText={setResendText}
                            setShowActivationCodeBox={setShowActivationCodeBox}
                            setOtp={setOtp}
                          />
                        </span>
                      </div>
                      <div className="activation-code-bottom-sheet__button">
                        <button
                          ref={activationCodeButtonRef}
                          className="btn btn--primary u-width-100"
                          disabled={true}
                        >
                          {!isLoading ? "ثبت" : <DotLoading/>}
                        </button>
                        <div className="error-box u-margin-top-small-1">
                          {errors?.map((error: any) => {
                            return (
                              <p className="error-box__content">
                                {error.message}
                              </p>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </BottomSheet>
                </>
                <div className="u-margin-bottom-big-6-5">
                  <div className="login__form--inputs">
                    {showActivationCodeBox && (
                      <div className="input-holder">
                        <input
                          name="activationCode"
                          className={
                            errors?.some(
                              (v: any) => v.field === "activationCode"
                            )
                              ? "input-error"
                              : ""
                          }
                          placeholder="کد فعالسازی"
                          autoComplete="off"
                          ref={activationCodeTag}
                          onChange={checkActivationCode}
                          onKeyPress={onPress}
                          hidden
                        />
                      </div>
                    )}

                    <div className="input-holder">
                      <input
                        disabled={
                          showActivationCodeBox ? Boolean(true) : Boolean(false)
                        }
                        className={
                          errors?.some((v: any) => v.field === "nationalId")
                            ? "input-error"
                            : ""
                        }
                        name="nationalId"
                        placeholder="کد ملی"
                        autoComplete="off"
                        onChange={onChange}
                        onKeyPress={onPress}
                        autoFocus
                      />
                    </div>
                    {windowSize < 500 ?
                      <div className="input-holder">
                        <input
                          disabled={
                            showActivationCodeBox ? Boolean(true) : Boolean(false)
                          }
                          name="birthDate"
                          className={
                            errors?.some((v: any) => v.field === "birthDate")
                              ? "input-error"
                              : ""
                          }
                          onChange={onChange}
                          type="text"
                          value={inputDateValue}
                          placeholder="تاریخ تولد"
                          onFocus={handleShowDatePicker}
                          onClick={handleShowDatePicker}
                          readOnly
                        />
                      </div> : <BirthDatePickerWithSeparateSelect date={date} setDate={setDate}
                                                                  onBirthDateChange={onBirthDateChange}/>
                    }
                    <div className="input-holder">
                      <input
                        disabled={
                          showActivationCodeBox ? Boolean(true) : Boolean(false)
                        }
                        name="mobileNumber"
                        className={
                          errors?.some((v: any) => v.field === "mobileNumber")
                            ? "input-error"
                            : ""
                        }
                        autoComplete="off"
                        onChange={onChange}
                        onKeyPress={onPress}
                        placeholder="تلفن همراه"
                      />
                    </div>
                    <div className="input-holder captcha-input">
                      <div className="captcha-input__img">
                        <img
                          className="captcha-input__img--base64"
                          src={`data:image/png;base64, ${captchaCode}`}
                          alt=""
                        />
                        <RefreshLogo onHandleRefreshLogo={handleCaptcha}/>
                      </div>
                      <input
                        disabled={
                          showActivationCodeBox && isDisabledCaptcha
                            ? Boolean(true)
                            : Boolean(false)
                        }
                        name="captcha"
                        className={
                          errors?.some((v: any) => v.field === "captcha")
                            ? "input-error"
                            : ""
                        }
                        maxLength={7}
                        autoComplete="off"
                        type="text"
                        placeholder="کد امنیتی"
                        onChange={onCaptchaChange}
                        id={inputCaptchaId}
                        ref={captchaTag}
                      />
                    </div>
                  </div>
                  <div className="error-box u-margin-top-small-1">
                    {errors?.map((error: any) => {
                      return (
                        <p className="error-box__content">{error.message}</p>
                      );
                    })}
                  </div>
                </div>

                <div className="login__form--button">
                  {!isLoading ? (
                    <button
                      className="btn btn--primary medium"
                      disabled={showTimer}
                    >
                      {showTimer ? (
                        <TimeCounter
                          onHandleCaptcha={handleCaptcha}
                          onHandleDisableCaptcha={setIsDisabledCaptcha}
                          onHandleEmptyCaptchaTag={emptyCaptchaTag}
                          onHandleSetShowTimer={setShowtimer}
                        />
                      ) : !resendText ? (
                        "ارسال کد فعال سازی"
                      ) : (
                        "ارسال مجدد کد فعال سازی"
                      )}
                    </button>
                  ) : (
                    <div className="btn btn--primary medium">
                      <DotLoading/>
                    </div>
                  )}
                </div>
                <div className="u-width-100 u-margin-top-small-1">
                  <a href={process.env.REACT_APP_SSO_URL} className="btn--link u-width-80 u-font-1-4">
                    ورود از طریق پنجره ملی خدمات دولت هوشمند
                  </a>
                </div>
              </form>
            </div>
            <h6 className="faq-typo" onClick={showFaq}>
              <div className="faq-typo__icon">
                <i>i</i>
              </div>
              <span>سوالات متداول</span>
            </h6>
          </section>
        </main>
      )}
    </>
  );
};
export default Login;
